module.exports = __webpack_public_path__ + "img/grain.287d259f.svg";